module.exports = __webpack_public_path__ + "img/discover.2f5020ec.svg";